import { loginRequestSchema } from '@instanexus/contracts';
import type { ApiClient } from '@instanexus/sdk';

import { saveFederatedReturn } from '@/lib/federated-return';

/** Remembers a sign-up round trip, starts it with the typed address as login_hint when it is an
 *  email, and leaves for the provider. Rejections (429, 404…) propagate to the caller's alert. */
export async function startGoogleSignUp(
  api: Pick<ApiClient, 'federation'>,
  email: string,
  redirectTo: (url: string) => void,
  storage?: Storage,
): Promise<void> {
  const hint = loginRequestSchema.shape.email.safeParse(email.trim());
  saveFederatedReturn(
    { kind: 'signup', ...(hint.success ? { loginHint: hint.data } : {}) },
    storage,
  );
  const { authorizeUrl } = await api.federation.start('google', {
    purpose: 'signup',
    ...(hint.success ? { loginHint: hint.data } : {}),
  });
  redirectTo(authorizeUrl);
}
